import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { HubEndpoint } from '../constants/hub-endpoint';
import { HubBrief, HubListSearchCriteria } from '../models';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class HubListService {
  constructor(private http: WrapperHttpService) {}

  getHubList(searchCriteria: HubListSearchCriteria): Observable<HubBrief[]> {
    const url = `${API_URL}${HubEndpoint.Base}?` + getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<HubBrief[]>(url);
  }
}
